import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Search, X, Calendar } from 'lucide-react';

export function SearchFilter({ data, onFilter, searchFields, placeholder = 'Search by name, ref number...' }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  const applyFilters = (search, from, to) => {
    let filtered = [...data];

    if (search.trim()) {
      const term = search.toLowerCase();
      filtered = filtered.filter(item =>
        searchFields.some(field => {
          const val = item[field];
          return val && String(val).toLowerCase().includes(term);
        })
      );
    }

    if (from) {
      const fromDate = new Date(from);
      fromDate.setHours(0, 0, 0, 0);
      filtered = filtered.filter(item => {
        const itemDate = new Date(item.created_at);
        return itemDate >= fromDate;
      });
    }

    if (to) {
      const toDate = new Date(to);
      toDate.setHours(23, 59, 59, 999);
      filtered = filtered.filter(item => {
        const itemDate = new Date(item.created_at);
        return itemDate <= toDate;
      });
    }

    onFilter(filtered);
  };

  const handleSearch = (val) => {
    setSearchTerm(val);
    applyFilters(val, dateFrom, dateTo);
  };

  const handleDateFrom = (val) => {
    setDateFrom(val);
    applyFilters(searchTerm, val, dateTo);
  };

  const handleDateTo = (val) => {
    setDateTo(val);
    applyFilters(searchTerm, dateFrom, val);
  };

  const clearAll = () => {
    setSearchTerm('');
    setDateFrom('');
    setDateTo('');
    onFilter(data);
  };

  const hasFilters = searchTerm || dateFrom || dateTo;

  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="search-filter-bar">
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <Input
          data-testid="search-input"
          value={searchTerm}
          onChange={(e) => handleSearch(e.target.value)}
          placeholder={placeholder}
          className="pl-10"
        />
      </div>
      <div className="flex items-center gap-2">
        <Calendar className="w-4 h-4 text-slate-400" />
        <Input
          data-testid="date-from-input"
          type="date"
          value={dateFrom}
          onChange={(e) => handleDateFrom(e.target.value)}
          className="w-[150px]"
        />
        <span className="text-slate-400 text-sm">to</span>
        <Input
          data-testid="date-to-input"
          type="date"
          value={dateTo}
          onChange={(e) => handleDateTo(e.target.value)}
          className="w-[150px]"
        />
      </div>
      {hasFilters && (
        <button
          onClick={clearAll}
          className="flex items-center gap-1 text-sm text-slate-500 hover:text-slate-700"
          data-testid="clear-filters-btn"
        >
          <X className="w-4 h-4" /> Clear
        </button>
      )}
    </div>
  );
}
